import compact from 'lodash/compact'
import moment from 'moment'
import * as Yup from 'yup'

Yup.addMethod(Yup.object, 'validateFeedbackClassField', (errorEmpty, errComment) =>
  Yup.object().test({
    name: 'validateFeedbackClassField',
    message: ({ value }) => {
      if (!value) return errorEmpty
      if (value?.rate < 3 && !value?.comment) {
        return errComment
      }
      return null
    },
    test: (value) => {
      if (!value) return false
      if (value?.rate < 3 && !value?.comment) {
        return false
      }
      return true
    },
    exclusive: false,
  })
)

Yup.addMethod(Yup.string, 'minWord', (wordCount, errorMessage) =>
  Yup.string().test({
    name: 'minWord',
    message: ({ value }) => {
      if (!value) {
        return errorMessage
      }
      return null
    },
    test: (value) => {
      if (!value) {
        return false
      }
      if (value && compact(value?.split(' '))?.length < wordCount) {
        return false
      }
      return true
    },
    exclusive: false,
  })
)

Yup.addMethod(Yup.string, 'minYear', (yearRequire, requiredErrorMessage, errorMessage) =>
  Yup.string().test({
    name: 'minYear',
    message: ({ value }) => {
      if (!value) {
        return requiredErrorMessage
      }

      if (moment().year() - moment(value * 1000).year() < yearRequire) {
        return errorMessage
      }
      return null
    },
    test: (value) => {
      if (!value) {
        return false
      }
      if (moment().year() - moment(value * 1000).year() < yearRequire) {
        return false
      }
      return true
    },
    exclusive: false,
  })
)

Yup.addMethod(Yup.string, 'minDate', (day, requiredErrorMessage, errorMessage) =>
  Yup.string().test({
    name: 'minDate',
    message: ({ value }) => {
      if (!value) {
        return requiredErrorMessage
      }
      if (moment(value * 1000).startOf('date').diff(moment().startOf('date'), 'days') < day) {
        return errorMessage
      }
      return null
    },
    test: (value) => {
      if (!value) {
        return false
      }
      if (moment(value * 1000).startOf('date').diff(moment().startOf('date'), 'days') < day) {
        return false
      }
      return true
    },
    exclusive: false,
  })
)

export const yupHelper = Yup
